import { PurchaseFromPublicGetAllInfo } from "@/api/services/transactionService";
import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import dayjs from "dayjs";

export interface InformationFormData {
  id: string;
  purchaseId: string;
  location: string;
  date: string;
  nameAsPerPan: string;
  manualNo: string;
  executiveId: string;
  modeId: string;
  cseId: string;
  sheduledTime: string;
  saleTypeId: string;
  travellerId: string;
  identityName: string;
  identityId: string;
  serviceTypeId: string;
  countryVisitedId: string;
  corporateClientId: string;
  residentialStatusId: string;
  travellerEmployeeCode: string;
  placeOfSupplyId: string;
  dealerId: string;
  dealerType:string
  panOrForm60: string;
  // cdfNumber: string;
  inclusiveGst: boolean;
  suspeciousTransaction: boolean;
  suspicious: Suspicious;
  remark1: string;
  remark2: string;
  remark3: string;
  inclusiveGstValue: string;
  // arrivalDate: string;
  purchaseDetail: DetailFormData[];
  purchaseCommission: CommissionFormData[];
  purchasePayment: PaymentFormData[];
  purchaseDocument: DocumentFormData;
  cdfForm: CDFFormData;
}

export type Suspicious = {
  id: string;
  purchasePublicPurchaseId: string;
  traVellerName: string;
  purposeOfTransaction: string;
  purposeCode: string;
  occupation: string;
  riskId: string;
  riskName: string;
  travellerRelocationSince: string;
  proceedsOfCrime: boolean;
  complexTransaction: boolean;
  economicRationale: boolean;
  financingOfTerrorism: boolean;
  priorityRatingId: string;
  priorityRatingName: string;
  relationSince: string;
  legal: string;
  status: number;
};

export interface DetailFormData {
  purchaseId?: string;
  productId: string;
  currencyId: string;
  denomination: string;
  quantity: number;
  rate: number;
  btqSurrender: boolean;
  transactionPurchaseId?: string;
  typeId?: string;
  vtmId?: string;
  value: string;
  prefix: string;
  from: string;
  to: string;
  cardNo: string;
}

export interface CommissionFormData {
  purchaseId?: string;
  agentId: string;
  currency: number;
  vtm: number;
}

export interface PaymentFormData {
  purchaseId?: string;
  paymentId: string;
  amount: number;
  account: string;
  chequeNumber: string;
  bankName: string;
  chequeDate: string;
}

export interface DocumentFormData {
  purchaseId: string;
  id: string;
  file?: any;
  fileName: string;
  remark: string;
  inclusiveGst: boolean;
  inclusiveGstValue: string;
}
export interface CDFFormData {
  purchaseId: string;
  id: string;
  file?: any;
  fileName: string;
  cdfNumber: string;
  arrivalDate: string;
}

interface PurchaseFormState {
  info: InformationFormData;
  editInfo: InformationFormData;
  error: string | undefined;
}

const initialInfo: InformationFormData = {
  id: "",
  purchaseId: "",
  location: "",
  nameAsPerPan: "",
  date: dayjs().toISOString(),
  manualNo: "",
  executiveId: "",
  modeId: "",
  cseId: "",
  sheduledTime: "",
  saleTypeId: "",
  travellerId: "",
  identityName: "",
  identityId: "",
  serviceTypeId: "",
  countryVisitedId: "",
  corporateClientId: "",
  residentialStatusId: "",
  travellerEmployeeCode: "",
  placeOfSupplyId: "",
  dealerId:"",
  dealerType: "",
  panOrForm60: "",
  // cdfNumber: "",
  inclusiveGst: false,
  suspeciousTransaction: false,
  suspicious: {
    id: "",
    purchasePublicPurchaseId: "",
    traVellerName: "",
    purposeOfTransaction: "",
    purposeCode: "",
    occupation: "",
    riskId: "",
    riskName: "",
    travellerRelocationSince: "",
    proceedsOfCrime: false,
    complexTransaction: false,
    economicRationale: false,
    financingOfTerrorism: false,
    priorityRatingId: "",
    priorityRatingName: "",
    relationSince: "",
    legal: "",
    status: 0,
  },
  remark1: "",
  remark2: "",
  remark3: "",
  inclusiveGstValue: "",
  // arrivalDate: "",
  purchaseDetail: [],
  purchaseCommission: [],
  purchasePayment: [],
  purchaseDocument: {
    purchaseId: "",
    id: "",
    fileName: "",
    remark: "No Remarks",
    inclusiveGst: false,
    inclusiveGstValue: "",
  },
  cdfForm: {
    purchaseId: "",
    id: "",
    fileName: "",
    cdfNumber: "",
    arrivalDate: "",
  },
};

const initialState: PurchaseFormState = {
  info: { ...initialInfo },
  editInfo: { ...initialInfo },
  error: "",
};

export const fetchPurchaseInfo = createAsyncThunk<
  InformationFormData,
  string,
  { rejectValue: string }
>("purchaseForm/fetchPurchaseInfo", async (taskid, { rejectWithValue }) => {
  try {
    const response = await PurchaseFromPublicGetAllInfo.getAll(taskid);
    console.log(response.data, "slice data");
    return response.data;
  } catch (error: any) {
    return rejectWithValue(error.message || "Failed to fetch information");
  }
});

const purchaseSlice = createSlice({
  name: "purchaseForm",
  initialState,
  reducers: {
    setPurchaseInformationData(
      state,
      action: PayloadAction<InformationFormData>
    ) {
      state.info = action.payload;
    },
    setPurchaseDetailData(state, action: PayloadAction<DetailFormData[]>) {
      state.info.purchaseDetail = action.payload;
    },
    setPurchaseCommissionData(
      state,
      action: PayloadAction<CommissionFormData[]>
    ) {
      state.info.purchaseCommission = action.payload;
    },
    setPurchasePaymentData(state, action: PayloadAction<PaymentFormData[]>) {
      state.info.purchasePayment = action.payload;
    },
    setPurchaseDocument(state, action: PayloadAction<DocumentFormData>) {
      state.info.purchaseDocument = action.payload;
    },
    setPurchaseCDF(state, action: PayloadAction<CDFFormData>) {
      state.info.cdfForm = action.payload;
    },
    resetPurchaseForm(state) {
      state.info = { ...initialInfo };
      state.editInfo = { ...initialInfo };
      state.error = "";
    },
    setEditPurchaseInformationData(
      state,
      action: PayloadAction<InformationFormData>
    ) {
      state.editInfo = action.payload;
    },
    setEditPurchaseCommissionData(
      state,
      action: PayloadAction<CommissionFormData[]>
    ) {
      state.editInfo.purchaseCommission = action.payload;
    },
    setEditPurchaseDetailData(state, action: PayloadAction<DetailFormData[]>) {
      state.editInfo.purchaseDetail = action.payload;
    },
    setEditPurchasePaymentData(
      state,
      action: PayloadAction<PaymentFormData[]>
    ) {
      state.editInfo.purchasePayment = action.payload;
    },
    setEditPurchaseDocumentData(
      state,
      action: PayloadAction<DocumentFormData>
    ) {
      state.editInfo.purchaseDocument = action.payload;
    },
    setEditPurchaseCDFData(
      state,
      action: PayloadAction<CDFFormData>
    ) {
      state.editInfo.cdfForm = action.payload;
    },
    setEditPurchaseSuspicious(state, action: PayloadAction<Suspicious>) {
      state.editInfo.suspicious = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPurchaseInfo.pending, (state) => {
        state.error = undefined;
      })
      .addCase(fetchPurchaseInfo.fulfilled, (state, action) => {
        state.editInfo = action.payload;
        sessionStorage.setItem("purchaseid", action.payload.purchaseId);
        sessionStorage.setItem("PurchaseId", action.payload.purchaseId);
      })
      .addCase(fetchPurchaseInfo.rejected, (state, action) => {
        state.error =
          typeof action.payload == "string"
            ? action.payload
            : "Unknown error occured";
      });
  },
});
export const {
  setEditPurchaseInformationData,
  setPurchaseDetailData,
  setPurchaseCommissionData,
  setPurchasePaymentData,
  setPurchaseDocument,
  setPurchaseCDF,
  setEditPurchaseDocumentData,
  setEditPurchaseCDFData,
  setEditPurchaseDetailData,
  setEditPurchaseCommissionData,
  setEditPurchasePaymentData,
  setPurchaseInformationData,
  resetPurchaseForm,
  setEditPurchaseSuspicious,
} = purchaseSlice.actions;
export default purchaseSlice.reducer;
